// extracted by mini-css-extract-plugin
var _1 = "ManageMembership_container__OCHjf";
var _2 = "ManageMembership_linkContainer__-nsU+";
var _3 = "ManageMembership_linkSubTitle__5Gf4t";
var _4 = "ManageMembership_linkTitle__Fm2vB";
var _5 = "768px";
var _6 = "\"../../shared.module.css\"";
export { _1 as "container", _2 as "linkContainer", _3 as "linkSubTitle", _4 as "linkTitle", _5 as "md", _6 as "shared" }
